function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*jshint esversion: 6 */
import { ComponentBase } from "./Shared/ComponentBase";
import { I18N } from "./Shared/I18n";
import { URLSearchParameters } from "./Shared/URLSearchParameters";
import { SubscriptionsApiService } from "./Services/SubscriptionsApiService";
export var MppUnsubscribe = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppUnsubscribe, _ComponentBase);

  var _super = _createSuper(MppUnsubscribe);

  function MppUnsubscribe() {
    _classCallCheck(this, MppUnsubscribe);

    return _super.call(this);
  }

  _createClass(MppUnsubscribe, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      console.log("Attribute changed!", "".concat(name, " changed from ").concat(oldValue, " to ").concat(newValue));
      this.loadAttributes();
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      this.mySubscriptionsTargetUrl = this.getAttribute("mysubscriptionswidgettargeturl");
    }
  }, {
    key: "createI18N",
    value: function createI18N() {
      return new I18N(MppUnsubscribe.WidgetDetails.tag);
    }
  }, {
    key: "getRoot",
    value: function getRoot() {
      return  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div class="mppw-component-container mpp-subscriptions"><div id="loadingContainer"><i class="mppw-spinner"></i></div><div id="componentContainer" class="componentContainer" style="display:none;"><p><b>Email: <span id="emailToUnsubscribe"></span></b></p><div id="resultMessageContainer" class="mppw-alert" style="display: none;"><div class="mppw-alert__icon"></div><span id="resultMessageText" class="mppw-alert__text"></span></div><div class="mppw-row"><div class="mppw-col-4"><button class="mppw-btn primary" id="mySubscriptionsButton" style="display: none;">${this._i18n.mySubscriptionsButtonText}</button></div><div class="mppw-col-4"><button class="mppw-btn primary" id="undoButton" style="display: none;">${this._i18n.undoButtonText}</button></div></div></div></div>` ;
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var i18n, urlParams;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.createI18N();

              case 3:
                i18n = _context.sent;
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                if (_context.t0.toString().startsWith("TypeError")) {
                  this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                } else {
                  this._root.innerHTML = "".concat(_context.t0);
                }

                return _context.abrupt("return");

              case 10:
                this._i18n = i18n; // HTML Template:

                this._root.innerHTML = this.getRoot(); // Get url params

                urlParams = new URLSearchParameters(window.location.search);
                console.log(urlParams);
                this.contactGuid = urlParams.get("cg");
                this.publicationId = urlParams.get("pubid") || 0;
                console.log('pub id', this.publicationId);
                this._$resultMessageContainer = this._root.querySelector("#resultMessageContainer");
                this._$resultMessageText = this._root.querySelector("#resultMessageText");
                this._$undoButton = this._root.querySelector("#undoButton");
                this._$mySubscriptionsButton = this._root.querySelector("#mySubscriptionsButton");
                this._$emailToUnsubscribe = this._root.querySelector("#emailToUnsubscribe");
                this._$loadingContainer = this._root.querySelector("#loadingContainer");
                this._$componentContainer = this._root.querySelector("#componentContainer"); // Wire-up event listeners:

                this._$undoButton.addEventListener("click", function (event) {
                  _this.UndoUnsubscribe();
                });

                this._$mySubscriptionsButton.addEventListener("click", function (event) {
                  window.location = _this.mySubscriptionsTargetUrl;
                }); // Automatically unsubscribe on load


                this.Unsubscribe(); // Determine whether or not to display my subscriptions button

                this.DisplayMySubscriptionsUrl();

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "getSubscriptionsApiService",
    value: function getSubscriptionsApiService() {
      return new SubscriptionsApiService();
    }
  }, {
    key: "Unsubscribe",
    value: function Unsubscribe() {
      var _this2 = this;

      var _service = this.getSubscriptionsApiService();

      _service.Unsubscribe(this.contactGuid, this.publicationId).then(function (data) {
        _this2._$loadingContainer.style.display = "none";
        _this2._$componentContainer.style.display = "block";
        _this2._$emailToUnsubscribe.innerHTML = data.emailAddress;

        if (data.success === true) {
          // Display message
          if (_this2.publicationId > 0) {
            var msg = _this2._i18n.successfulUnsubscribeLabel;

            _this2.SetMessage("success", msg);
          } else {
            var msg = _this2._i18n.successfulBulkEmailOptOut;

            _this2.SetMessage("success", msg);
          } // Show undo button


          _this2._$undoButton.style.display = "block";
        } else {
          _this2.SetMessage("Warning", _this2._i18n.unableToUnsubscribeError);
        }
      })["catch"](function (error) {
        _this2._$loadingContainer.style.display = "none";
        _this2._$componentContainer.style.display = "block";

        _this2.SetMessage("danger", _this2._i18n.unableToUnsubscribeError);

        console.log(error);
      });
    }
  }, {
    key: "UndoUnsubscribe",
    value: function UndoUnsubscribe() {
      var _this3 = this;

      var _service = this.getSubscriptionsApiService();

      _service.UndoUnsubscribe(this.contactGuid, this.publicationId).then(function (data) {
        if (data.success === true) {
          // Display message
          var msg = _this3._i18n.undoUnsubscribeSuccess;

          _this3.SetMessage("success", msg);
        } else {
          _this3.SetMessage("Warning", _this3._i18n.unableToUndoUnsubscribeError);
        } // Hide undo button


        _this3._$undoButton.style.display = "none";
      })["catch"](function (error) {
        console.log(error);

        _this3.SetMessage("danger", _this3._i18n.unableToUndoUnsubscribeError);
      });
    }
  }, {
    key: "DisplayMySubscriptionsUrl",
    value: function DisplayMySubscriptionsUrl() {
      if (!!this.mySubscriptionsTargetUrl) {
        this._$mySubscriptionsButton.style.display = "block";
      } else {
        this._$mySubscriptionsButton.style.display = "none";
      }
    }
  }, {
    key: "SetMessage",
    value: function SetMessage(status, message) {
      this._$resultMessageContainer.classList.remove("mppw-alert__success");

      this._$resultMessageContainer.classList.remove("mppw-alert__info");

      this._$resultMessageContainer.classList.remove("mppw-alert__warning");

      this._$resultMessageContainer.classList.remove("mppw-alert__danger");

      this._$resultMessageContainer.classList.add("mppw-alert__".concat(status));

      this._$resultMessageText.innerHTML = message;
      this._$resultMessageContainer.style.display = "";
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "One-Click Unsubscribe",
        tag: "mpp-unsubscribe",
        configurationItems: [{
          name: "Target URL",
          attribute: "mysubscriptionswidgettargeturl",
          description: "Identifies the URL where the My Subscriptions Widget is configured.",
          required: false,
          type: "url"
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["mysubscriptionswidgettargeturl"];
    }
  }]);

  return MppUnsubscribe;
}(ComponentBase);
MppUnsubscribe.registerComponent(MppUnsubscribe.WidgetDetails.tag, MppUnsubscribe);